import { useVisit } from '../VisitContext';
import { VisitBucketItemWrapper } from '../shared/VisitBucketItemWrapper';

import { WorkflowStageTaskProvider } from '~/features/workflowing/tasks/WorkflowStageTaskContext';
import type { WorkflowStageTaskViewModel } from '@generated';
import { useQuery } from '@tanstack/react-query';
import { useGetVisitStatusOptions, useGetWorkflowStageTaskForVisitOptions } from '../queries';
import { VisitWorkflowStageTaskFooter } from './VisitWorkflowStageTaskFooter';

export function VisitWorkflowStageTask({ workflowStageTask }: { workflowStageTask: WorkflowStageTaskViewModel }) {
	const { id, selectedVisitBucket, navigateToNextItem } = useVisit();
	const { refetch: refetchWorkflowTask } = useQuery(useGetWorkflowStageTaskForVisitOptions(id, selectedVisitBucket.id, workflowStageTask.id));
	const { refetch: refetchVisitStatus } = useQuery(useGetVisitStatusOptions(id));

	return (
		<WorkflowStageTaskProvider
			workflowStageTask={workflowStageTask}
			sectionWrapper={(children, { isResolvedView, disableSubmitOnResolved }) => (
				<VisitBucketItemWrapper
					footerSlot={
						<VisitWorkflowStageTaskFooter
							workflowStageTask={workflowStageTask}
							isResolvedView={isResolvedView}
							disableSubmitOnResolved={disableSubmitOnResolved}
						/>
					}
				>
					{children}
				</VisitBucketItemWrapper>
			)}
			onSuccess={() => {
				if (!workflowStageTask.resolved) {
					refetchWorkflowTask();
					refetchVisitStatus();
				}
				navigateToNextItem?.();
			}}
		/>
	);
}
